<input id="toggle-sidebar-checkbox" type="checkbox" role="button" class="toggle-sidebar-checkbox" />
<label for="toggle-sidebar-checkbox" class="toggle-sidebar"></label>

<!-- Desktop View -->
@if (isDesktop) {
  <div class="sidebar">
    <div class="map-location">
      <label for="place-search-desktop">Enter a location:</label>
      <app-google-place-search [placeHolder]='' title='' showCurrentLocation=true
        [locationModel]="this.locationModel"
        id="place-search-desktop"
        useCurrentLocationIcon="true"
        (onSubmit)="onFindLocation($event)"
        [currentLocation]='locationModel.Name'
      (onValueChanged)='onFindLocation($event)'></app-google-place-search>
      <aa-route-plan-button [title]="'Find'" [isLoading]="locationModel.isLoading" (click)="onFindLocation(false)"></aa-route-plan-button>
    </div>
    <aa-map-options [optionData]="mapsHotelsModel.mapsOptionsData" (optionSelected)="mapOptionsChanged($event)"></aa-map-options>
  </div>
}


<!-- Mobile View -->
@if (!isDesktop) {
  <div class="toggle_content" >
    <div class="wrapper" [ngClass]="{'close': !mapMobileMenu.toggleMenu}">
      @if (mapMobileMenu.searchActive) {
        <div class="map-location">
          <label for="place-search-mobile" [ngClass]="{'location-not-found':isLocationFeature}">Enter a location:</label>
          <app-google-place-search [placeHolder]='' title='' showCurrentLocation=true
            [locationModel]="this.locationModel"
            id="place-search-mobile"
            useCurrentLocationIcon="true"
            (onSubmit)="onFindLocation($event)"
            [currentLocation]='locationModel.Name'
          (onValueChanged)='onFindLocation($event)'></app-google-place-search>
          <aa-route-plan-button [title]="'Find'" [isLoading]="locationModel.isLoading" (click)="onFindLocation(false)"></aa-route-plan-button>
        </div>
      }
      @if (mapMobileMenu.mapActive) {
          <aa-map-options [optionData]="mapsHotelsModel.mapsOptionsData" (optionSelected)="mapOptionsChanged($event)"></aa-map-options>
      }
    </div>
    <button class="toogle_button" (click)="mapMobileMenu.toggleMenus()" [ngClass]="{'closed': !mapMobileMenu.toggleMenu}">
      <span class='icon-up'></span>
    </button>
  </div>
}

<!-- Desktop & Mobile View -->
<div class="content" >
  <div class="map-container">
    <aa-hybrid-google-map [mapType]="2" ></aa-hybrid-google-map>
  </div>
</div>

<!-- Mobile View -->
@if (!isDesktop) {
  <div class="ads-sticky-mobile">
    <aa-app-advertisement class="ads-sticky-mobile" type="the-aa-mpu-mobile"></aa-app-advertisement>
  </div>
}